export default __webpack_public_path__ + "static/first-visitor-83f7c3cd035b8991cdeb65bf22452fb1.png";